import React from 'react';
import { Icon } from '../../../icon/Icon';

export interface MenuSearchInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  testId?: string;
}

export const MenuSearchInput = ({ value, onChange, placeholder = 'Search...', testId }: MenuSearchInputProps) => {
  return (
    <div className="px-4 py-2 border-0 border-b border-solid border-b-venn-grey-30">
      <div className="flex items-center pl-3 border-solid border-venn-grey-30 rounded-[4px]">
        <Icon type="search" className="text-black text-[14px] flex-shrink-0" />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onClick={(e) => e.stopPropagation()}
          data-testid={testId}
          className="flex-1 border-none outline-none text-[12px] font-normal text-black bg-transparent placeholder:text-venn-grey-60"
        />
      </div>
    </div>
  );
};
